webpackJsonp([24],{

/***/ 1538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SoftwareShortcuts_vue__ = __webpack_require__(1909);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1aeaa52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SoftwareShortcuts_vue__ = __webpack_require__(2350);
function injectStyle (ssrContext) {
  __webpack_require__(2342)
  __webpack_require__(2344)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e1aeaa52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SoftwareShortcuts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1aeaa52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SoftwareShortcuts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(1546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(1555);
function injectStyle (ssrContext) {
  __webpack_require__(1553)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64c87b52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Otwarte modale w kolejności otwierania. Esc zamyka tylko ostatni, żeby przy
// zagnieżdżonych modalach (np. wykres otwierany z modala szczegółów alarmów)
// nie zamykały się wszystkie naraz.
var openModals = [];

// Esc w otwartej liście vue-select / vue-multiselect zamyka samą listę; przy
// otwartym kalendarzu vue2-datepicker też nie ruszamy modala, żeby jednym
// klawiszem nie stracić wypełnionego formularza.
var OPEN_DROPDOWN = '.vs--open, .multiselect--active';
var OPEN_DATEPICKER = '.mx-datepicker-popup';

// Faza capture: sprawdzamy listy, zanim ich własna obsługa Esc je zamknie.
function onDocumentKeydown(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var topModal = openModals[openModals.length - 1];
    if (topModal == null) return;

    var target = event.target;
    if (target instanceof Element && target.closest(OPEN_DROPDOWN) != null) return;
    if (document.querySelector(OPEN_DATEPICKER) != null) return;

    topModal.$emit('close');
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Modal',
    props: {
        showDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        maxWidth: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        showDialog: {
            immediate: true,
            handler: function handler(isOpen) {
                isOpen ? this.registerOpen() : this.unregisterOpen();
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.unregisterOpen();
    },

    computed: {
        style: function style() {
            return 'max-width: ' + this.maxWidth;
        }
    },
    methods: {
        registerOpen: function registerOpen() {
            if (openModals.includes(this)) return;
            openModals.push(this);
            if (openModals.length === 1) {
                document.addEventListener('keydown', onDocumentKeydown, true);
            }
        },
        unregisterOpen: function unregisterOpen() {
            var index = openModals.indexOf(this);
            if (index === -1) return;
            openModals.splice(index, 1);
            if (openModals.length === 0) {
                document.removeEventListener('keydown', onDocumentKeydown, true);
            }
        }
    }
});

/***/ }),

/***/ 1546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  emits: ['onClick'],
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    buttonClass: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    onClick: function onClick() {
      this.$emit('onClick');
    }
  },
  computed: {
    buttonDef: function buttonDef() {
      return this.buttonClass === '' ? 'my-button' : '' + this.buttonClass;
    }
  }
});

/***/ }),

/***/ 1547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(1545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1551);
function injectStyle (ssrContext) {
  __webpack_require__(1549)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-330662f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1550);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("6de141c4", content, true, {});

/***/ }),

/***/ 1550:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-330662f6]{position:fixed;z-index:110;left:0;top:0;width:100%;height:100%;overflow:auto;display:block;background-color:rgba(0,0,0,.4)}.flex-container[data-v-330662f6]{height:100%;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex}.modal-content[data-v-330662f6]{margin:auto;background-color:#fefefe;border:unset;width:auto;z-index:1000;border-radius:5px;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.2);box-shadow:0 4px 10px rgba(0,0,0,.2)}.modal-header[data-v-330662f6]{background-color:#34758e;width:100%;font-family:SourceSansProBold,sans-serif;font-size:16px;font-style:normal;font-weight:600;color:#fff}.close[data-v-330662f6]{color:#fff;float:right;font-size:28px;font-weight:700}.close[data-v-330662f6]:focus,.close[data-v-330662f6]:hover{color:#000;text-decoration:none;cursor:pointer}.widthClass[data-v-330662f6]{max-width:30%}#mdiv[data-v-330662f6]{width:25px;height:25px;cursor:pointer}.mdiv[data-v-330662f6]{height:25px;width:2px;margin-left:12px;background-color:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg);Z-index:1}.md[data-v-330662f6]{height:25px;width:2px;background-color:#fff;-webkit-transform:rotate(90deg);transform:rotate(90deg);Z-index:2}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Modal.vue"],"names":[],"mappings":"AACA,wBACI,eAAgB,AAGhB,YAAa,AACb,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,cAAe,AACf,cAAe,AACf,+BAAkC,CACrC,AACD,iCACI,YAAa,AACb,UAAW,AACX,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AAKD,gCACI,YAAa,AACb,yBAA0B,AAC1B,aAAc,AACd,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,6CAAiD,AACzC,oCAAyC,CACpD,AACD,+BACI,yBAA2B,AAC3B,WAAY,AACZ,yCAA6C,AAC7C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,UAAa,CAChB,AACD,wBACI,WAAa,AACb,YAAa,AACb,eAAgB,AAChB,eAAkB,CACrB,AACD,4DAEI,WAAa,AACb,qBAAsB,AACtB,cAAgB,CACnB,AACD,6BACI,aAAe,CAClB,AAKD,uBACE,WAAY,AACZ,YAAa,AACb,cAAgB,CACjB,AACD,uBACE,YAAa,AACb,UAAW,AACX,iBAAkB,AAClB,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ,AACD,qBACE,YAAa,AACb,UAAW,AACX,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ","file":"Modal.vue","sourcesContent":["\n.modal[data-v-330662f6] {\n    position: fixed;\n    /* Nad paskiem górnym (.app-header, z-index 20) i mobilnym menu (99/100),\n       ale pod popupami doklejanymi do body (Syncfusion 1000, datepicker 2001). */\n    z-index: 110;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    display: block;\n    background-color: rgba(0,0,0,0.4);\n}\n.flex-container[data-v-330662f6] {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n/* margin: auto zamiast align-items/justify-content: center — modal wyższy od\n   ekranu zaczyna się od góry i da się go przewinąć do nagłówka z krzyżykiem\n   (przy centrowaniu flexem jego górna część wystawała poza ekran). */\n.modal-content[data-v-330662f6] {\n    margin: auto;\n    background-color: #fefefe;\n    border: unset;\n    width: auto;\n    z-index: 1000;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n            box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n}\n.modal-header[data-v-330662f6] {\n    background-color:  #34758E;\n    width: 100%;\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    color: white;\n}\n.close[data-v-330662f6] {\n    color: white;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n}\n.close[data-v-330662f6]:hover,\n.close[data-v-330662f6]:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n}\n.widthClass[data-v-330662f6] {\n    max-width: 30%;\n}\n.modal-slot[data-v-330662f6] {\n    /* margin-right: 10px;\n    margin-left: 10px; */\n}\n#mdiv[data-v-330662f6] {\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n.mdiv[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  margin-left: 12px;\n  background-color: white;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  Z-index: 1;\n}\n.md[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  background-color: white;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  Z-index: 2;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal flex-container"},[_c('div',{staticClass:"modal-content vertical",style:(_vm.style)},[_c('div',{staticClass:"modal-header"},[(_vm.title != undefined)?_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title != null ? _vm.title : '')+" ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"mdiv"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-slot"},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdiv"},[_c('div',{staticClass:"md"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1553:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1554);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("9f84328e", content, true, {});

/***/ }),

/***/ 1554:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".my-button[data-v-64c87b52]{background:transparent;outline:none;border:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Button.vue"],"names":[],"mappings":"AACA,4BACI,uBAAwB,AACxB,aAAc,AACd,WAAa,CAChB","file":"Button.vue","sourcesContent":["\n.my-button[data-v-64c87b52] {\n    background: transparent;\n    outline: none;\n    border: none;\n}\n.my-button[data-v-64c87b52]:hover {\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonDef,attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$t(_vm.title))+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Button__ = __webpack_require__(1544);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        title: {
            type: String,
            required: false
        },
        text: {
            type: String,
            required: false,
            default: ''
        },
        alternativeDeleteText: {
            type: String,
            required: false,
            default: 'AreYouSureDelete'
        }
    },
    watch: {},
    methods: {
        confirm: function confirm() {
            this.$emit('confirm');
        },
        cancel: function cancel() {
            this.$emit('cancel');
        }
    },
    computed: {},
    components: {
        Button: __WEBPACK_IMPORTED_MODULE_0__components_Button__["a" /* default */]
    },
    mounted: function mounted() {},
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ 1579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteConfirm_vue__ = __webpack_require__(1563);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_905c32ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteConfirm_vue__ = __webpack_require__(1582);
function injectStyle (ssrContext) {
  __webpack_require__(1580)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-905c32ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_905c32ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteConfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1580:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1581);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("727af110", content, true, {});

/***/ }),

/***/ 1581:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"DeleteConfirm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-5 pr-5"},[_c('p',{staticClass:"mb-0 pt-4",staticStyle:{"text-align":"center","font-weight":"600","font-size":"18px"}},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t(_vm.alternativeDeleteText)))]),_vm._v(" "),_c('div',{staticClass:"row d-flex justify-content-between pb-4 mt-4 ml-4 mr-4"},[_c('div',{staticClass:"col flex-grow pr-2"},[_c('Button',{attrs:{"title":_vm.$t('Cancel'),"buttonClass":"cancel-button semi-bold w-100"},on:{"onClick":_vm.cancel}})],1),_vm._v(" "),_c('div',{staticClass:"col flex-grow pl-2"},[_c('Button',{attrs:{"title":_vm.$t('Delete'),"buttonClass":"delete-button semi-bold w-100"},on:{"onClick":_vm.confirm}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BYTES_PER_MB = 1048576;

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ProgressBar',
    props: {
        loaded: {
            type: Number,
            default: 0
        },
        total: {
            type: Number,
            default: 0
        }
    },
    computed: {
        indeterminate: function indeterminate() {
            return !(this.total > 0);
        },
        percent: function percent() {
            if (this.indeterminate) return 0;
            return Math.min(100, this.loaded / this.total * 100);
        },
        label: function label() {
            if (this.indeterminate) {
                // Size unknown: show what we have, or "Preparing" before any bytes.
                return this.loaded > 0 ? this.toMB(this.loaded) + ' MB' : this.$t('Preparing');
            }
            return this.toMB(this.loaded) + ' MB / ' + this.toMB(this.total) + ' MB';
        }
    },
    methods: {
        toMB: function toMB(bytes) {
            return (bytes / BYTES_PER_MB).toFixed(2);
        }
    }
});

/***/ }),

/***/ 1607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__ = __webpack_require__(1603);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4018aa0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__ = __webpack_require__(1667);
function injectStyle (ssrContext) {
  __webpack_require__(1665)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d4018aa0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4018aa0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseProgress;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);

// Cross-browser parsing of axios up/download progress events.
//
// axios 1.x sets `progressEvent.total` to `undefined` whenever the transfer is
// not length-computable. For downloads this happens routinely when the response
// is gzip/br compressed, chunked or streamed – and whether it happens depends on
// the server<->browser content negotiation, which is why the old code worked in
// some browsers/setups but not others.
//
// To behave identically everywhere we recover the total from, in order:
//   1. progressEvent.total          (reliable, only set when length-computable)
//   2. a caller-supplied known size (e.g. the file's real byte size)
//   3. the Content-Length response header read straight off the XHR
// and, when none is available, we report `indeterminate` so the UI can render an
// animated "in progress" bar instead of a stuck/NaN one.

function parseProgress(progressEvent) {
    var fallbackTotal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var loaded = toPositive(progressEvent && progressEvent.loaded) || 0;

    var total = toPositive(progressEvent && progressEvent.total);

    if (!total) {
        total = toPositive(fallbackTotal);
    }

    if (!total) {
        total = toPositive(contentLength(progressEvent));
    }

    // A total smaller than the bytes already transferred means the header
    // describes the compressed payload while `loaded` counts decompressed
    // bytes – the percentage would be meaningless, so treat it as unknown.
    if (total && loaded > total) {
        total = 0;
    }

    return {
        loaded: loaded,
        total: total,
        indeterminate: !total
    };
}

function contentLength(progressEvent) {
    var xhr = progressEvent && progressEvent.event && progressEvent.event.target;
    if (xhr && typeof xhr.getResponseHeader === 'function') {
        return Number(xhr.getResponseHeader('Content-Length'));
    }
    return 0;
}

function toPositive(value) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(value) && value > 0 ? value : 0;
}

/***/ }),

/***/ 1665:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1666);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("74e4044a", content, true, {});

/***/ }),

/***/ 1666:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".progress-container[data-v-d4018aa0]{margin:10px 20px}.progress-head[data-v-d4018aa0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;margin-bottom:6px;font-size:14px;color:#414f51}.progress-percent[data-v-d4018aa0]{font-weight:600;color:#356c88}.crfi-progress[data-v-d4018aa0]{position:relative;width:100%;height:12px;border-radius:6px;background-color:#e3ebee;-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.1);box-shadow:inset 0 1px 2px rgba(0,0,0,.1);overflow:hidden}.crfi-progress-bar[data-v-d4018aa0]{height:100%;border-radius:6px;background-color:#356c88;-webkit-transition:width .2s linear;transition:width .2s linear}.crfi-progress-bar.indeterminate[data-v-d4018aa0]{position:absolute;left:0;top:0;width:40%;-webkit-animation:crfi-progress-indeterminate-data-v-d4018aa0 1.4s ease-in-out infinite;animation:crfi-progress-indeterminate-data-v-d4018aa0 1.4s ease-in-out infinite}@-webkit-keyframes crfi-progress-indeterminate-data-v-d4018aa0{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{-webkit-transform:translateX(250%);transform:translateX(250%)}}@keyframes crfi-progress-indeterminate-data-v-d4018aa0{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{-webkit-transform:translateX(250%);transform:translateX(250%)}}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/ProgressBar.vue"],"names":[],"mappings":"AACA,qCACI,gBAAkB,CACrB,AACD,gCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,2BAA4B,AACxB,wBAAyB,AACrB,qBAAsB,AAC9B,kBAAmB,AACnB,eAAgB,AAChB,aAAe,CAClB,AACD,mCACI,gBAAiB,AACjB,aAAe,CAClB,AACD,gCACI,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,yBAA0B,AAC1B,kDAAuD,AAC/C,0CAA+C,AACvD,eAAiB,CACpB,AACD,oCACI,YAAa,AACb,kBAAmB,AACnB,yBAA0B,AAC1B,oCAAsC,AACtC,2BAA8B,CACjC,AACD,kDACI,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,UAAW,AACX,wFAAyF,AACjF,+EAAiF,CAC5F,AACD,+DACA,GAAO,oCAAqC,AAAC,2BAA6B,CACzE,AACD,GAAK,mCAAoC,AAAC,0BAA4B,CACrE,CACA,AACD,uDACA,GAAO,oCAAqC,AAAC,2BAA6B,CACzE,AACD,GAAK,mCAAoC,AAAC,0BAA4B,CACrE,CACA","file":"ProgressBar.vue","sourcesContent":["\n.progress-container[data-v-d4018aa0] {\n    margin: 10px 20px;\n}\n.progress-head[data-v-d4018aa0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: baseline;\n        -ms-flex-align: baseline;\n            align-items: baseline;\n    margin-bottom: 6px;\n    font-size: 14px;\n    color: #414F51;\n}\n.progress-percent[data-v-d4018aa0] {\n    font-weight: 600;\n    color: #356C88;\n}\n.crfi-progress[data-v-d4018aa0] {\n    position: relative;\n    width: 100%;\n    height: 12px;\n    border-radius: 6px;\n    background-color: #e3ebee;\n    -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n            box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n}\n.crfi-progress-bar[data-v-d4018aa0] {\n    height: 100%;\n    border-radius: 6px;\n    background-color: #356C88;\n    -webkit-transition: width 0.2s linear;\n    transition: width 0.2s linear;\n}\n.crfi-progress-bar.indeterminate[data-v-d4018aa0] {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 40%;\n    -webkit-animation: crfi-progress-indeterminate-data-v-d4018aa0 1.4s ease-in-out infinite;\n            animation: crfi-progress-indeterminate-data-v-d4018aa0 1.4s ease-in-out infinite;\n}\n@-webkit-keyframes crfi-progress-indeterminate-data-v-d4018aa0 {\nfrom { -webkit-transform: translateX(-100%); transform: translateX(-100%);\n}\nto { -webkit-transform: translateX(250%); transform: translateX(250%);\n}\n}\n@keyframes crfi-progress-indeterminate-data-v-d4018aa0 {\nfrom { -webkit-transform: translateX(-100%); transform: translateX(-100%);\n}\nto { -webkit-transform: translateX(250%); transform: translateX(250%);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-container vertical"},[_c('div',{staticClass:"progress-head"},[_c('span',{staticClass:"progress-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(!_vm.indeterminate)?_c('span',{staticClass:"progress-percent"},[_vm._v(_vm._s(_vm.percent.toFixed(0))+"%")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"crfi-progress",attrs:{"role":"progressbar","aria-valuemin":"0","aria-valuemax":_vm.indeterminate ? null : _vm.total,"aria-valuenow":_vm.indeterminate ? null : _vm.loaded}},[(_vm.indeterminate)?_c('div',{staticClass:"crfi-progress-bar indeterminate"}):_c('div',{staticClass:"crfi-progress-bar",style:({ width: _vm.percent + '%' })})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1668:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1669), __esModule: true };

/***/ }),

/***/ 1669:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1670);
module.exports = __webpack_require__(105).Number.isFinite;


/***/ }),

/***/ 1670:
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(183);
var _isFinite = __webpack_require__(80).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),

/***/ 1909:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal_vue__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Button_vue__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DeleteConfirm_vue__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Software_SoftwareShortcutModal_vue__ = __webpack_require__(2346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ProgressBar_vue__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_progress__ = __webpack_require__(1608);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var context = null;

/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Modal: __WEBPACK_IMPORTED_MODULE_4__components_Modal_vue__["a" /* default */], Button: __WEBPACK_IMPORTED_MODULE_5__components_Button_vue__["a" /* default */], DeleteConfirm: __WEBPACK_IMPORTED_MODULE_6__components_DeleteConfirm_vue__["a" /* default */], SoftwareShortcutModal: __WEBPACK_IMPORTED_MODULE_7__components_Software_SoftwareShortcutModal_vue__["a" /* default */], ProgressBar: __WEBPACK_IMPORTED_MODULE_8__components_ProgressBar_vue__["a" /* default */] },
    data: function data() {
        return {
            shortcuts: [],
            loading: true,
            activeModal: null,
            selectedShortcut: null,
            actionText: null,
            // progress
            bytesReceived: 0,
            bytesToReceive: 0,
            downloadController: null
        };
    },

    methods: {
        copyLink: function copyLink(shortcut) {
            navigator.clipboard.writeText(this.$http.defaults.baseURL + ('Updater/version/' + shortcut.versionId));
            var x = document.getElementById("snackbar");
            x.className = "show";
            x.innerHTML = this.$t('Copied') + ' - ' + shortcut.name;
            setTimeout(function () {
                x.className = x.className.replace("show", "");
            }, 3000);
        },
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loading = true;
                                _this.$store.dispatch('set_loading', true);
                                _context.prev = 2;
                                _context.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api__["_56" /* getSoftwareShortcutCards */])();

                            case 5:
                                _this.shortcuts = _context.sent;

                            case 6:
                                _context.prev = 6;

                                _this.loading = false;
                                _this.$store.dispatch('set_loading', false);
                                return _context.finish(6);

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[2,, 6, 10]]);
            }))();
        },
        initials: function initials(name) {
            if (!name) {
                return '?';
            }
            return name.trim().substring(0, 2).toUpperCase();
        },
        openModal: function openModal(shortcut, modal) {
            this.selectedShortcut = shortcut;
            this.activeModal = modal;
        },
        openDeleteModal: function openDeleteModal(shortcut) {
            this.selectedShortcut = shortcut;
            this.actionText = this.$t('DeleteShortcut') + ': ' + shortcut.name;
            this.activeModal = 'DELETE';
        },
        closeModal: function closeModal(isGetData) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!isGetData) {
                                    _context2.next = 3;
                                    break;
                                }

                                _context2.next = 3;
                                return _this2.getData();

                            case 3:
                                _this2.activeModal = null;
                                _this2.selectedShortcut = null;
                                _this2.actionText = null;

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        deleteShortcutConfirm: function deleteShortcutConfirm() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api__["B" /* deleteSoftwareShortcut */])(_this3.selectedShortcut.id);

                            case 2:
                                _this3.closeModal(true);

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        downloadVersion: function downloadVersion(id, fileName) {
            var _this4 = this;

            var knownSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var followConfig, blob, a, url;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this4.activeModal = 'Progress';
                                _this4.bytesReceived = 0;
                                _this4.bytesToReceive = 0;
                                _this4.downloadController = new AbortController();

                                followConfig = {
                                    signal: _this4.downloadController.signal,
                                    onDownloadProgress: function onDownloadProgress(progressEvent) {
                                        var _parseProgress = Object(__WEBPACK_IMPORTED_MODULE_9__util_progress__["a" /* parseProgress */])(progressEvent, knownSize),
                                            loaded = _parseProgress.loaded,
                                            total = _parseProgress.total;

                                        context.bytesReceived = loaded;
                                        context.bytesToReceive = total;
                                    }
                                };
                                _context4.prev = 5;
                                _context4.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api__["_97" /* getVersionById */])(id, followConfig);

                            case 8:
                                blob = _context4.sent;
                                a = document.createElement("a");

                                document.body.appendChild(a);
                                a.style = "display: none";

                                url = window.URL.createObjectURL(blob.data);

                                a.href = url;
                                a.download = fileName;
                                a.click();
                                window.URL.revokeObjectURL(url);
                                a.remove();
                                _context4.next = 23;
                                break;

                            case 20:
                                _context4.prev = 20;
                                _context4.t0 = _context4['catch'](5);

                                if (!__WEBPACK_IMPORTED_MODULE_3_axios__["default"].isCancel(_context4.t0)) {
                                    console.dir(_context4.t0);
                                }

                            case 23:
                                _context4.prev = 23;

                                _this4.activeModal = null;
                                _this4.downloadController = null;
                                return _context4.finish(23);

                            case 27:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4, [[5, 20, 23, 27]]);
            }))();
        },
        cancelDownload: function cancelDownload() {
            if (this.downloadController) {
                this.downloadController.abort();
            }
            this.activeModal = null;
        }
    },
    mounted: function mounted() {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            context = _this5;
                            _context5.next = 3;
                            return _this5.getData();

                        case 3:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    }
});

/***/ }),

/***/ 1910:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api_js__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button_vue__ = __webpack_require__(1544);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Button: __WEBPACK_IMPORTED_MODULE_3__Button_vue__["a" /* default */] },
    props: {
        // Existing shortcut to edit, or null when adding a new one.
        current: {
            type: Object,
            default: null
        }
    },
    data: function data() {
        return {
            shortcut: {
                id: null,
                name: '',
                product: '',
                platform: '',
                architecture: 'any',
                description: '',
                iconBase64: null
            },
            products: [],
            platforms: [],
            architectures: [],
            error: ''
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api_js__["_55" /* getSoftwareProducts */])();

                            case 2:
                                _this.products = _context.sent;
                                _context.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api_js__["_54" /* getSoftwarePlatforms */])();

                            case 5:
                                _this.platforms = _context.sent;
                                _context.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api_js__["_14" /* getArchitectures */])();

                            case 8:
                                _this.architectures = _context.sent;

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        selectIcon: function selectIcon() {
            this.$refs.iconInput.click();
        },
        onIconChange: function onIconChange(e) {
            var _this2 = this;

            var file = e.target.files[0];
            if (!file) {
                return;
            }

            if (file.size > 1048576) {
                this.error = this.$t('IconTooLarge');
                return;
            }

            var reader = new FileReader();
            reader.onload = function () {
                _this2.shortcut.iconBase64 = reader.result;
            };
            reader.readAsDataURL(file);
        },
        save: function save() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(!_this3.shortcut.name || !_this3.shortcut.product || !_this3.shortcut.platform)) {
                                    _context2.next = 3;
                                    break;
                                }

                                _this3.error = _this3.$t('ShortcutRequiredFields');
                                return _context2.abrupt('return');

                            case 3:

                                _this3.error = '';

                                _context2.prev = 4;

                                if (!_this3.shortcut.id) {
                                    _context2.next = 10;
                                    break;
                                }

                                _context2.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api_js__["O" /* editSoftwareShortcut */])(_this3.shortcut);

                            case 8:
                                _context2.next = 12;
                                break;

                            case 10:
                                _context2.next = 12;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api_js__["i" /* addSoftwareShortcut */])(_this3.shortcut);

                            case 12:
                                _this3.$emit('saved');
                                _context2.next = 19;
                                break;

                            case 15:
                                _context2.prev = 15;
                                _context2.t0 = _context2['catch'](4);

                                console.dir(_context2.t0);
                                _this3.error = _context2.t0;

                            case 19:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3, [[4, 15]]);
            }))();
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return _this4.getData();

                        case 2:

                            if (_this4.current) {
                                _this4.shortcut = {
                                    id: _this4.current.id,
                                    name: _this4.current.name,
                                    product: _this4.current.product,
                                    platform: _this4.current.platform,
                                    architecture: _this4.current.architecture || 'any',
                                    description: _this4.current.description,
                                    iconBase64: _this4.current.iconBase64 || null
                                };
                            }

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this4);
        }))();
    }
});

/***/ }),

/***/ 2342:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2343);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("5cd0f956", content, true, {});

/***/ }),

/***/ 2343:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".cards-grid[data-v-e1aeaa52]{display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:20px;margin-top:20px}.shortcut-card[data-v-e1aeaa52]{position:relative;background:#f9f9f9;border-radius:8px;-webkit-box-shadow:0 0 20px rgba(53,110,138,.18);box-shadow:0 0 20px rgba(53,110,138,.18);padding:20px;min-height:240px}.card-actions[data-v-e1aeaa52]{position:absolute;top:10px;right:10px;gap:8px}.card-action[data-v-e1aeaa52]{cursor:pointer;padding:4px}.card-icon[data-v-e1aeaa52]{width:72px;height:72px;margin:6px auto 14px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.card-icon img[data-v-e1aeaa52]{max-width:100%;max-height:100%;-o-object-fit:contain;object-fit:contain}.card-icon-placeholder[data-v-e1aeaa52]{width:72px;height:72px;border-radius:12px;background:#34758e;color:#fff;font-weight:700;font-size:24px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.card-name[data-v-e1aeaa52]{text-align:center;font-size:16px;margin:0 0 8px;color:#272727}.card-tags[data-v-e1aeaa52]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:6px;margin-bottom:8px}.tag[data-v-e1aeaa52]{background:#e6eef2;color:#34758e;border-radius:12px;padding:2px 10px;font-size:11px;font-weight:600}.card-description[data-v-e1aeaa52]{text-align:center;font-size:12px;color:#6b6b6b;margin:0 0 10px}.card-version[data-v-e1aeaa52]{text-align:center;margin-bottom:10px}.version-badge[data-v-e1aeaa52]{font-size:13px;font-weight:700;color:#2e7d32}.version-badge.unavailable[data-v-e1aeaa52]{color:#9e9e9e;font-weight:600;font-style:italic}.empty-state[data-v-e1aeaa52]{text-align:center;color:#9e9e9e;margin-top:40px}.progress-container[data-v-e1aeaa52]{margin:10px 20px}#upload-progress[data-v-e1aeaa52]{height:20px;border-radius:5px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Software/SoftwareShortcuts.vue"],"names":[],"mappings":"AACA,6BACI,aAAc,AACd,0DAA6D,AAC7D,SAAU,AACV,eAAiB,CACpB,AACD,gCACI,kBAAmB,AACnB,mBAAoB,AACpB,kBAAmB,AACnB,iDAA0D,AAClD,yCAAkD,AAC1D,aAAc,AACd,gBAAkB,CACrB,AACD,+BACI,kBAAmB,AACnB,SAAU,AACV,WAAY,AACZ,OAAS,CACZ,AACD,8BACI,eAAgB,AAChB,WAAa,CAChB,AACD,4BACI,WAAY,AACZ,YAAa,AACb,qBAA2B,AAC3B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,gCACI,eAAgB,AAChB,gBAAiB,AACjB,sBAAuB,AACpB,kBAAoB,CAC1B,AACD,wCACI,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,mBAAoB,AACpB,WAAa,AACb,gBAAiB,AACjB,eAAgB,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,4BACI,kBAAmB,AACnB,eAAgB,AAChB,eAAkB,AAClB,aAAe,CAClB,AACD,4BACI,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,mBAAoB,AAChB,eAAgB,AACpB,QAAS,AACT,iBAAmB,CACtB,AACD,sBACI,mBAAoB,AACpB,cAAe,AACf,mBAAoB,AACpB,iBAAkB,AAClB,eAAgB,AAChB,eAAiB,CACpB,AACD,mCACI,kBAAmB,AACnB,eAAgB,AAChB,cAAe,AACf,eAAmB,CACtB,AACD,+BACI,kBAAmB,AACnB,kBAAoB,CACvB,AACD,gCACI,eAAgB,AAChB,gBAAiB,AACjB,aAAe,CAClB,AACD,4CACI,cAAe,AACf,gBAAiB,AACjB,iBAAmB,CACtB,AACD,8BACI,kBAAmB,AACnB,cAAe,AACf,eAAiB,CACpB,AACD,qCACI,gBAAkB,CACrB,AACD,kCACI,YAAa,AACb,iBAAmB,CACtB","file":"SoftwareShortcuts.vue","sourcesContent":["\n.cards-grid[data-v-e1aeaa52] {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n    gap: 20px;\n    margin-top: 20px;\n}\n.shortcut-card[data-v-e1aeaa52] {\n    position: relative;\n    background: #F9F9F9;\n    border-radius: 8px;\n    -webkit-box-shadow: 0px 0px 20px rgba(53, 110, 138, 0.18);\n            box-shadow: 0px 0px 20px rgba(53, 110, 138, 0.18);\n    padding: 20px;\n    min-height: 240px;\n}\n.card-actions[data-v-e1aeaa52] {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    gap: 8px;\n}\n.card-action[data-v-e1aeaa52] {\n    cursor: pointer;\n    padding: 4px;\n}\n.card-icon[data-v-e1aeaa52] {\n    width: 72px;\n    height: 72px;\n    margin: 6px auto 14px auto;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.card-icon img[data-v-e1aeaa52] {\n    max-width: 100%;\n    max-height: 100%;\n    -o-object-fit: contain;\n       object-fit: contain;\n}\n.card-icon-placeholder[data-v-e1aeaa52] {\n    width: 72px;\n    height: 72px;\n    border-radius: 12px;\n    background: #34758E;\n    color: white;\n    font-weight: 700;\n    font-size: 24px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.card-name[data-v-e1aeaa52] {\n    text-align: center;\n    font-size: 16px;\n    margin: 0 0 8px 0;\n    color: #272727;\n}\n.card-tags[data-v-e1aeaa52] {\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    gap: 6px;\n    margin-bottom: 8px;\n}\n.tag[data-v-e1aeaa52] {\n    background: #E6EEF2;\n    color: #34758E;\n    border-radius: 12px;\n    padding: 2px 10px;\n    font-size: 11px;\n    font-weight: 600;\n}\n.card-description[data-v-e1aeaa52] {\n    text-align: center;\n    font-size: 12px;\n    color: #6b6b6b;\n    margin: 0 0 10px 0;\n}\n.card-version[data-v-e1aeaa52] {\n    text-align: center;\n    margin-bottom: 10px;\n}\n.version-badge[data-v-e1aeaa52] {\n    font-size: 13px;\n    font-weight: 700;\n    color: #2e7d32;\n}\n.version-badge.unavailable[data-v-e1aeaa52] {\n    color: #9e9e9e;\n    font-weight: 600;\n    font-style: italic;\n}\n.empty-state[data-v-e1aeaa52] {\n    text-align: center;\n    color: #9e9e9e;\n    margin-top: 40px;\n}\n.progress-container[data-v-e1aeaa52] {\n    margin: 10px 20px;\n}\n#upload-progress[data-v-e1aeaa52] {\n    height: 20px;\n    border-radius: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2344:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2345);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("9a38bd98", content, true, {});

/***/ }),

/***/ 2345:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".add-shortcut-button{padding:8px 18px}.add-shortcut-button,.download-button{background:#34758e;color:#fff;border-radius:4px;cursor:pointer}.disabled-button,.download-button{padding:8px 0;width:100%}.disabled-button{background:#cfcfcf;color:#fff;border-radius:4px;cursor:not-allowed}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Software/SoftwareShortcuts.vue"],"names":[],"mappings":"AACA,qBAII,gBAAkB,CAErB,AACD,sCANI,mBAAoB,AACpB,WAAa,AACb,kBAAmB,AAEnB,cAAgB,CASnB,AACD,kCAJI,cAAe,AACf,UAAY,CAUf,AAPD,iBACI,mBAAoB,AACpB,WAAe,AACf,kBAAmB,AAGnB,kBAAoB,CACvB","file":"SoftwareShortcuts.vue","sourcesContent":["\n.add-shortcut-button {\n    background: #34758E;\n    color: white;\n    border-radius: 4px;\n    padding: 8px 18px;\n    cursor: pointer;\n}\n.download-button {\n    background: #34758E;\n    color: white;\n    border-radius: 4px;\n    padding: 8px 0;\n    width: 100%;\n    cursor: pointer;\n}\n.disabled-button {\n    background: #cfcfcf;\n    color: #ffffff;\n    border-radius: 4px;\n    padding: 8px 0;\n    width: 100%;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SoftwareShortcutModal_vue__ = __webpack_require__(1910);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18bbc6d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SoftwareShortcutModal_vue__ = __webpack_require__(2349);
function injectStyle (ssrContext) {
  __webpack_require__(2347)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18bbc6d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SoftwareShortcutModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18bbc6d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SoftwareShortcutModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2347:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2348);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("d2d9d93e", content, true, {});

/***/ }),

/***/ 2348:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".icon-preview[data-v-18bbc6d4]{width:72px;height:72px;border-radius:8px;border:1px solid #e9e9e9;background:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;overflow:hidden}.icon-preview.empty[data-v-18bbc6d4]{border-style:dashed;color:#9e9e9e;font-size:11px;text-align:center}.icon-preview img[data-v-18bbc6d4]{max-width:100%;max-height:100%;-o-object-fit:contain;object-fit:contain}.file-select[data-v-18bbc6d4]{cursor:pointer;border-radius:4px;border:1px solid #34758e;background:#34758e;color:#fff;padding:6px 14px;font-weight:600;margin-bottom:6px}.link-button[data-v-18bbc6d4]{background:transparent;border:none;color:#346f8b;cursor:pointer;font-size:12px;text-decoration:underline;padding:0}.error[data-v-18bbc6d4]{font-size:14px;color:#c0392b}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Software/SoftwareShortcutModal.vue"],"names":[],"mappings":"AACA,+BACI,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,yBAA0B,AAC1B,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,eAAiB,CACpB,AACD,qCACI,oBAAqB,AACrB,cAAe,AACf,eAAgB,AAChB,iBAAmB,CACtB,AACD,mCACI,eAAgB,AAChB,gBAAiB,AACjB,sBAAuB,AACpB,kBAAoB,CAC1B,AACD,8BACI,eAAgB,AAChB,kBAAmB,AACnB,yBAA0B,AAC1B,mBAAoB,AACpB,WAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,8BACI,uBAAwB,AACxB,YAAa,AACb,cAAe,AACf,eAAgB,AAChB,eAAgB,AAChB,0BAA2B,AAC3B,SAAW,CACd,AACD,wBACI,eAAgB,AAChB,aAAe,CAClB","file":"SoftwareShortcutModal.vue","sourcesContent":["\n.icon-preview[data-v-18bbc6d4] {\n    width: 72px;\n    height: 72px;\n    border-radius: 8px;\n    border: 1px solid #E9E9E9;\n    background: #fff;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    overflow: hidden;\n}\n.icon-preview.empty[data-v-18bbc6d4] {\n    border-style: dashed;\n    color: #9e9e9e;\n    font-size: 11px;\n    text-align: center;\n}\n.icon-preview img[data-v-18bbc6d4] {\n    max-width: 100%;\n    max-height: 100%;\n    -o-object-fit: contain;\n       object-fit: contain;\n}\n.file-select[data-v-18bbc6d4] {\n    cursor: pointer;\n    border-radius: 4px;\n    border: 1px solid #34758E;\n    background: #34758E;\n    color: white;\n    padding: 6px 14px;\n    font-weight: 600;\n    margin-bottom: 6px;\n}\n.link-button[data-v-18bbc6d4] {\n    background: transparent;\n    border: none;\n    color: #346F8B;\n    cursor: pointer;\n    font-size: 12px;\n    text-decoration: underline;\n    padding: 0;\n}\n.error[data-v-18bbc6d4] {\n    font-size: 14px;\n    color: #c0392b;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical grow gallery-container",staticStyle:{"height":"100%"}},[_c('div',{staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('ShortcutName')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"400px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.shortcut.name),expression:"shortcut.name"}],staticClass:"datalist-input",staticStyle:{"width":"100%"},domProps:{"value":(_vm.shortcut.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.shortcut, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Product')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"400px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.shortcut.product),expression:"shortcut.product"}],staticClass:"datalist-input",staticStyle:{"width":"100%"},attrs:{"list":"shortcut-products-list"},domProps:{"value":(_vm.shortcut.product)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.shortcut, "product", $event.target.value)}}}),_vm._v(" "),_c('datalist',{attrs:{"id":"shortcut-products-list"}},_vm._l((_vm.products),function(p){return _c('option',{key:p,domProps:{"value":p}},[_vm._v(_vm._s(p))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Platform')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"400px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.shortcut.platform),expression:"shortcut.platform"}],staticClass:"datalist-input",staticStyle:{"width":"100%"},attrs:{"list":"shortcut-platforms-list"},domProps:{"value":(_vm.shortcut.platform)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.shortcut, "platform", $event.target.value)}}}),_vm._v(" "),_c('datalist',{attrs:{"id":"shortcut-platforms-list"}},_vm._l((_vm.platforms),function(p){return _c('option',{key:p,domProps:{"value":p}},[_vm._v(_vm._s(p))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Architecture')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"400px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.shortcut.architecture),expression:"shortcut.architecture"}],staticClass:"datalist-input",staticStyle:{"width":"100%"},attrs:{"list":"shortcut-architectures-list"},domProps:{"value":(_vm.shortcut.architecture)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.shortcut, "architecture", $event.target.value)}}}),_vm._v(" "),_c('datalist',{attrs:{"id":"shortcut-architectures-list"}},_vm._l((_vm.architectures),function(p){return _c('option',{key:p,domProps:{"value":p}},[_vm._v(_vm._s(p))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Description')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"400px"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.shortcut.description),expression:"shortcut.description"}],staticStyle:{"height":"75px","width":"100%"},attrs:{"type":"text","placeholder":"Content"},domProps:{"value":(_vm.shortcut.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.shortcut, "description", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Icon')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"400px"}},[_c('div',{staticClass:"horizontal",staticStyle:{"align-items":"center"}},[_c('div',{staticClass:"icon-preview",class:{ empty: !_vm.shortcut.iconBase64 }},[(_vm.shortcut.iconBase64)?_c('img',{attrs:{"src":_vm.shortcut.iconBase64}}):_c('span',[_vm._v(_vm._s(_vm.$t('NoIcon')))])]),_vm._v(" "),_c('div',{staticClass:"vertical",staticStyle:{"margin-left":"12px"}},[_c('button',{staticClass:"file-select",on:{"click":_vm.selectIcon}},[_vm._v(_vm._s(_vm.$t('SelectIcon')))]),_vm._v(" "),(_vm.shortcut.iconBase64)?_c('button',{staticClass:"link-button",on:{"click":function($event){_vm.shortcut.iconBase64 = null}}},[_vm._v(_vm._s(_vm.$t('RemoveIcon')))]):_vm._e(),_vm._v(" "),_c('input',{ref:"iconInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onIconChange}})])])])])]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"justify-content":"center","margin-bottom":"10px"}},[(_vm.error != '')?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])]),_vm._v(" "),_c('div',{staticStyle:{"align-self":"center","margin-bottom":"20px"}},[_c('Button',{staticStyle:{"width":"300px","align-self":"center"},attrs:{"title":_vm.$t('Save'),"buttonClass":"save-button semi-bold"},on:{"onClick":_vm.save}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('div',{attrs:{"id":"snackbar"}},[_vm._v(_vm._s(_vm.$t('Copied')))]),_vm._v(" "),_c('Modal',{attrs:{"title":_vm.$t('AddShortcut').toUpperCase(),"showDialog":_vm.activeModal === 'ADD'},on:{"close":function($event){return _vm.closeModal()}}},[_c('software-shortcut-modal',{attrs:{"current":null},on:{"cancel":function($event){return _vm.closeModal()},"saved":function($event){return _vm.closeModal(true)}}})],1),_vm._v(" "),_c('Modal',{attrs:{"title":_vm.$t('EditShortcut').toUpperCase(),"showDialog":_vm.activeModal === 'EDIT'},on:{"close":function($event){return _vm.closeModal()}}},[_c('software-shortcut-modal',{attrs:{"current":_vm.selectedShortcut},on:{"cancel":function($event){return _vm.closeModal()},"saved":function($event){return _vm.closeModal(true)}}})],1),_vm._v(" "),_c('Modal',{attrs:{"showDialog":_vm.activeModal === 'DELETE',"title":_vm.$t('DeleteShortcut').toUpperCase()},on:{"close":function($event){return _vm.closeModal()}}},[_c('delete-confirm',{attrs:{"text":_vm.actionText},on:{"cancel":function($event){return _vm.closeModal()},"confirm":_vm.deleteShortcutConfirm}})],1),_vm._v(" "),_c('Modal',{attrs:{"title":_vm.$t('DownloadProgress'),"showDialog":_vm.activeModal === 'Progress'},on:{"close":_vm.cancelDownload}},[_c('div',{staticClass:"progress-container vertical",staticStyle:{"min-width":"30vw"}},[_c('ProgressBar',{attrs:{"loaded":_vm.bytesReceived,"total":_vm.bytesToReceive}}),_vm._v(" "),_c('button',{staticClass:"cancel-button semi-bold",staticStyle:{"margin-top":"12px"},on:{"click":_vm.cancelDownload}},[_vm._v(_vm._s(_vm.$t('Cancel')))])],1)]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"justify-content":"space-between","align-items":"center"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('SoftwareDownloads')))]),_vm._v(" "),_c('Button',{attrs:{"buttonClass":"save-button semi-bold add-shortcut-button","title":_vm.$t('AddShortcut')},on:{"onClick":function($event){return _vm.openModal(null, 'ADD')}}})],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"empty-state"},[_c('p',[_vm._v(_vm._s(_vm.$t('Loading')))])]):(_vm.shortcuts.length === 0)?_c('div',{staticClass:"empty-state"},[_c('p',[_vm._v(_vm._s(_vm.$t('NoShortcuts')))])]):_c('div',{staticClass:"cards-grid"},_vm._l((_vm.shortcuts),function(shortcut){return _c('div',{key:shortcut.id,staticClass:"shortcut-card vertical"},[_c('div',{staticClass:"card-actions horizontal"},[(shortcut.hasVersion)?_c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({ theme : 'customTheme', placement : 'top', arrow : true }),expression:"{ theme : 'customTheme', placement : 'top', arrow : true }"}],staticClass:"card-action",attrs:{"content":_vm.$t('CopyLink')},on:{"click":function($event){return _vm.copyLink(shortcut)}}},[_c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21 8C21 6.34315 19.6569 5 18 5H10C8.34315 5 7 6.34315 7 8V20C7 21.6569 8.34315 23 10 23H18C19.6569 23 21 21.6569 21 20V8ZM19 8C19 7.44772 18.5523 7 18 7H10C9.44772 7 9 7.44772 9 8V20C9 20.5523 9.44772 21 10 21H18C18.5523 21 19 20.5523 19 20V8Z","fill":"#346F8B"}}),_c('path',{attrs:{"d":"M6 3H16C16.5523 3 17 2.55228 17 2C17 1.44772 16.5523 1 16 1H6C4.34315 1 3 2.34315 3 4V18C3 18.5523 3.44772 19 4 19C4.55228 19 5 18.5523 5 18V4C5 3.44772 5.44772 3 6 3Z","fill":"#346F8B"}})])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({ theme : 'customTheme', placement : 'top', arrow : true }),expression:"{ theme : 'customTheme', placement : 'top', arrow : true }"}],staticClass:"card-action",attrs:{"content":_vm.$t('Edit')},on:{"click":function($event){return _vm.openModal(shortcut, 'EDIT')}}},[_c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 27 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.64951 16.4004L7.64952 16.4003M7.64951 16.4004L7.64951 16.4004L7.64952 16.4003M7.64951 16.4004C7.64952 16.4004 7.64952 16.4003 7.64952 16.4003M7.64951 16.4004L7.64952 16.4003M14.95 7.25429L17.4952 9.61783L10.5666 16.0519L7.66216 16.3496L7.66203 16.3496C7.65971 16.3499 7.65755 16.35 7.65555 16.35L7.96842 13.737L14.95 7.25429ZM18.5296 4.83337L20.1732 6.35962C20.4089 6.57848 20.4091 6.91217 20.1731 7.13143L19.0692 8.15645L16.524 5.79293L17.5573 4.83337C17.8206 4.58888 18.2663 4.58888 18.5296 4.83337Z","stroke":"#346F8B","stroke-width":"1.3"}})])]),_vm._v(" "),_c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({ theme : 'customTheme', placement : 'top', arrow : true }),expression:"{ theme : 'customTheme', placement : 'top', arrow : true }"}],staticClass:"card-action",attrs:{"content":_vm.$t('Delete')},on:{"click":function($event){return _vm.openDeleteModal(shortcut)}}},[_c('svg',{attrs:{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3.5 1.4C3.5 0.626801 4.1268 0 4.9 0H9.1C9.8732 0 10.5 0.626801 10.5 1.4V2.8H11.8928C11.8971 2.79996 11.9014 2.79996 11.9058 2.8H13.3C13.6866 2.8 14 3.1134 14 3.5C14 3.8866 13.6866 4.2 13.3 4.2H12.5518L11.9447 12.6997C11.8923 13.4324 11.2827 14 10.5482 14H3.45178C2.71729 14 2.10767 13.4324 2.05534 12.6997L1.44822 4.2H0.7C0.313401 4.2 0 3.8866 0 3.5C0 3.1134 0.313401 2.8 0.7 2.8H2.09422C2.09856 2.79996 2.1029 2.79996 2.10722 2.8H3.5V1.4ZM4.9 2.8H9.1V1.4H4.9V2.8ZM2.85178 4.2L3.45178 12.6H10.5482L11.1482 4.2H2.85178ZM5.6 5.6C5.9866 5.6 6.3 5.9134 6.3 6.3V10.5C6.3 10.8866 5.9866 11.2 5.6 11.2C5.2134 11.2 4.9 10.8866 4.9 10.5V6.3C4.9 5.9134 5.2134 5.6 5.6 5.6ZM8.4 5.6C8.7866 5.6 9.1 5.9134 9.1 6.3V10.5C9.1 10.8866 8.7866 11.2 8.4 11.2C8.0134 11.2 7.7 10.8866 7.7 10.5V6.3C7.7 5.9134 8.0134 5.6 8.4 5.6Z","fill":"#346F8B"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-icon"},[(shortcut.iconBase64)?_c('img',{attrs:{"src":shortcut.iconBase64,"alt":shortcut.name}}):_c('div',{staticClass:"card-icon-placeholder"},[_vm._v(_vm._s(_vm.initials(shortcut.name)))])]),_vm._v(" "),_c('p',{staticClass:"card-name semi-bold"},[_vm._v(_vm._s(shortcut.name))]),_vm._v(" "),_c('div',{staticClass:"card-tags horizontal"},[_c('span',{staticClass:"tag"},[_vm._v(_vm._s(shortcut.platform))]),_vm._v(" "),(shortcut.architecture && shortcut.architecture !== 'any')?_c('span',{staticClass:"tag"},[_vm._v(_vm._s(shortcut.architecture))]):_vm._e()]),_vm._v(" "),(shortcut.description)?_c('p',{staticClass:"card-description"},[_vm._v(_vm._s(shortcut.description))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"grow"}),_vm._v(" "),_c('div',{staticClass:"card-version"},[(shortcut.hasVersion)?_c('span',{staticClass:"version-badge"},[_vm._v("v"+_vm._s(shortcut.softwareVersion))]):_c('span',{staticClass:"version-badge unavailable"},[_vm._v(_vm._s(_vm.$t('NoVersionAvailable')))])]),_vm._v(" "),(shortcut.hasVersion)?_c('Button',{attrs:{"buttonClass":"save-button semi-bold download-button","title":_vm.$t('Download')},on:{"onClick":function($event){return _vm.downloadVersion(shortcut.versionId, shortcut.fileName, shortcut.fileSize)}}}):_c('Button',{attrs:{"buttonClass":"disabled-button semi-bold download-button","title":_vm.$t('Download')}})],1)}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/24.d1299d2ca9b5adf5ed6e.js